import { Button, ButtonProps } from "@mui/material"
import { useTranslation } from "react-i18next"

const LoginButton = (props: ButtonProps) => {
    const { t } = useTranslation()

    return (
        <Button variant='outlined' {...props} style={{fontWeight:700}}>
            {t(`landing_page_login`)}
        </Button>
    )
}

export default LoginButton